import { render, staticRenderFns } from "./fiche-de-pret.vue?vue&type=template&id=5f1d3f8c&scoped=true&"
import script from "./fiche-de-pret.vue?vue&type=script&lang=js&"
export * from "./fiche-de-pret.vue?vue&type=script&lang=js&"
import style0 from "./fiche-de-pret.vue?vue&type=style&index=0&id=5f1d3f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d3f8c",
  null
  
)

export default component.exports